import { useEffect } from 'react';
import { useLocalStorage } from 'react-use';

import { URL_PARAMS } from 'constants/forms';

const useParamsDetectionUrl = () => {
  const [value, setValue] = useLocalStorage('params');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      const result = value ? { ...value } : {};

      URL_PARAMS.forEach((item) => {
        if (params.has(item)) result[item] = params.get(item);
      });

      if (Object.keys(result).length) setValue(result);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useParamsDetectionUrl;
